"use client";

import React from "react";
import { PortalCardWrapper, PortalText } from "../PortalCard/PortalCard";
import Box from "../Box";
import ImageView from "../ImageView";
import Flex from "../Flex";
import Text from "../Text";

type Props = {
  onClick: (e: React.MouseEvent) => void;
  fixedWidth?: boolean;
};

const EmptyPortalCard: React.FC<Props> = ({ onClick, ...rest }) => {
  return (
    <PortalCardWrapper onClick={onClick} width={"100%"} {...rest}>
      <Box width="100%">
        <ImageView
          css={{ cursor: "pointer" }}
          src={null}
          icon={"action.add"}
          alt={"Create a portal"}
          aspectRatio={3 / 1}
          cover
          background={"grayLightest"}
          borderRadius="small"
        />
      </Box>
      <Box mt="s">
        <Flex justifyContent="space-between">
          <Text as="h1" font="ui.regularSemiBold" truncate onClick={onClick}>
            {"Create a new portal"}
          </Text>
        </Flex>
        <PortalText font="ui.small" color="grayDarker" mt="xs">
          Portals are containers for your kits.
        </PortalText>
      </Box>
    </PortalCardWrapper>
  );
};

export default EmptyPortalCard;
